import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SecurityaddonsService } from '../../../../securityaddons/services/securityaddons.service';
import { CustomerQuestionnaireService } from '../../../services/customer-questionnaire.service';
import { AuthService } from '../../../../auth/services/auth.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { CustomerVerificationRequestsStatusService } from '../../../../customer-tasks/customer-verification-requests/services/customer-verification-requests-status.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate(
                    '1s ease-out',
                    style({
                        height: 50,
                        opacity: 1,
                    }),
                ),
            ]),
            transition(':leave', [
                style({ height: 50, opacity: 1 }),
                animate(
                    '1s ease-in',
                    style({
                        height: 0,
                        opacity: 0,
                    }),
                ),
            ]),
        ]),
    ],
    standalone: false,
})
export class BannerComponent implements OnInit {
    public isQuestionnaireLoaded = false;
    public showBreachBanner: boolean = true;
    public showCVRBanner: boolean = false;
    public cvrSubscription: Subscription;

    constructor(
        public customerQuestionnaireService: CustomerQuestionnaireService,
        public authService: AuthService,
        public router: Router,
        public customerVerificationService: CustomerVerificationRequestsStatusService,
        public securityAddonsService: SecurityaddonsService,
        public configService: ConfigService,
        public cdr: ChangeDetectorRef,
    ) {
        this.customerQuestionnaireService.isQuestionnaireLoaded().subscribe((loaded) => {
            this.isQuestionnaireLoaded = loaded;
        });
    }

    onCloseBannerClicked() {
        localStorage.setItem('isQuestionnaireResumed', 'true');
    }

    showBreachWarranty() {
        return (
            this.showBreachBanner &&
            this.securityAddonsService.breachWarrantyIntegration &&
            !this.securityAddonsService.breachWarrantyIntegration?.acknowledged &&
            this.securityAddonsService.breachWarrantyIntegration.warranty_type
        );
    }

    onCloseCVRBannerClicked() {
        localStorage.setItem('cvrBannerClosed', 'true');
    }

    ngOnInit(): void {
        if (this.router.url.includes('breach-warranty')) {
            this.showBreachBanner = false;
        }
        if (this.router.url.includes('customer-verification-requests')) {
            this.showCVRBanner = false;
        }
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart && (event as NavigationStart).url.includes('breach-warranty')) {
                this.showBreachBanner = false;
            } else if (event instanceof NavigationStart) {
                this.showBreachBanner = true;
            }
            if (event instanceof NavigationStart && (event as NavigationStart).url.includes('customer-verification-requests')) {
                this.showCVRBanner = false;
            } else if (event instanceof NavigationStart) {
                this.cvrSubscription = this.customerVerificationService.getAll().subscribe((value) => {
                    this.showCVRBanner =
                        (value as any)['customer-tasks']['customer-verification-requests']['banner'] &&
                        this.configService.getFeaturesConfig().enable_cvr === 'true';
                    this.cdr.detectChanges();
                    this.cvrSubscription.unsubscribe();
                });
            }
        });
    }

    showCVRNotification() {
        return this.showCVRBanner && !(localStorage.getItem('cvrBannerClosed') === 'true');
    }
}
